import { cn } from "@/lib/cn";

interface EyebrowProps {
  children: React.ReactNode;
  index?: string;
  className?: string;
  /** Ponto pulsante de "sistema ativo" */
  live?: boolean;
}

export default function Eyebrow({ children, index, className, live }: EyebrowProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border border-line/15 bg-white/[0.04] px-3.5 py-1.5 text-[11px] font-medium uppercase tracking-[0.14em] text-electric",
        className
      )}
    >
      {live && (
        <span className="relative flex h-1.5 w-1.5" aria-hidden="true">
          <span className="absolute inline-flex h-full w-full animate-pulse-ring rounded-full bg-electric" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-electric" />
        </span>
      )}
      {index && <span className="tabular-nums text-muted">{index}</span>}
      {children}
    </span>
  );
}
